import * as types from "../constants/actionTypes";

export const marketingEmailOptInReducerInitialState = {
    waiting: null,
    success: null,
    error: null,
    scrubbingIn: {
        waiting: null,
        success: null,
        error: null,
        errorRsp: null
    }
};

export default function marketingEmailOptInReducer(state = marketingEmailOptInReducerInitialState, action) {
    switch (action.type) {
        case types.SET_MARKETING_EMAIL_OPT_IN:
            return { ...state, waiting: true };
        case types.SET_MARKETING_EMAIL_OPT_IN_SUCCESS:
            return { ...state, waiting: false, success: true };
        case types.SET_MARKETING_EMAIL_OPT_IN_FAILURE:
            return { ...state, waiting: false, success: false, error: action.error };
        case types.SET_SCRUBBING_IN_EMAIL_OPT_IN:
            return {
                ...state, scrubbingIn: { waiting: true, success: null, error: null, errorRsp: null } };
        case types.SET_SCRUBBING_IN_EMAIL_OPT_IN_SUCCESS:
            return { ...state, scrubbingIn: { waiting: false, success: true, error: false, errorRsp: null } };
        case types.SET_SCRUBBING_IN_EMAIL_OPT_IN_FAILURE:
            return { ...state, scrubbingIn: { waiting: false, success: false, error: true, errorRsp: action.error } };
        case types.LOGOUT:
            return marketingEmailOptInReducerInitialState
        default:
            return { ...state };
    }
}
